<template>
    <div class="search-form-mask open">
        <input type="text" class="search-input" v-model="query" placeholder="Search for..">
        <input class="search-input__button" />
        <button class="btn btn-light sb-icon-search" v-on:click="search">
                <span class="fa fa-search">
                    <span class="visually-hidden">Search</span>
                </span>
        </button>
    </div>
</template>

<script>
import Utils from "../../Services/Utils";

export default {
        name: "SearchInput",
        props: {
            url: String,
            searchParams: Object
        },
        data: function () {
          return {
              query: '',
              builtUrl: '',
              params: {}
          }
        },
        methods: {
            search: function () {

                this.buildUrl();

                this.$emit('search-button-pressed');

                axios.get(this.builtUrl).then((res) => {
                    this.$emit('search-complete', {response:res, query: this.query});
                });

            },

            buildUrl: function () {
                let params = this.searchParams;
                params.query = this.query;

                this.builtUrl = Utils.buildUrl(this.url, params);
            }

        },

        mounted() {
            //
        }
    }
</script>

<style scoped>
    .search-input {
        position: absolute;
        top: 0;
        right: 0;
        outline: none;
        height: 30px;
        margin: 0;
        z-index: 10;

        font-family: inherit;
        border-radius: 22px;
        color: #babfbf;
        box-shadow: none;
        border: 1px solid #979ca2;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.6;
    }

    .search-input__button {
        background: #fff;
        filter: alpha(opacity=0);
        opacity: 0;
        color: transparent;
        border: none;
        outline: none;
        width: 25px;
    }
</style>
